import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { MenuItem, ListItemIcon, Typography } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import { useAtomValue } from 'jotai';
import { userBranchesAtom } from '../../Atoms';

const BranchSelectionWidget = function BranchSelectionWidget({
  branches = [],
  closeMenu = () => {},
  onClick,
}) {
  const userBranches = useAtomValue(userBranchesAtom);
  const intl = useIntl();

  const branchesArray =
    branches && branches.length > 0 ? branches : userBranches;

  return (
    <div style={{ padding: '8px' }}>
      <Typography
        variant="caption"
        color="primary"
        sx={{ fontWeight: 'bold', mt: '8px' }}
      >
        {intl.messages.BRANCHES}
      </Typography>
      {branchesArray &&
        Array.isArray(branchesArray) &&
        branchesArray.map((x, index) => (
          <MenuItem
            key={x.id}
            onClick={() => {
              onClick(x);
              closeMenu();
            }}
            value={x.branchDescription}
            divider={index !== branchesArray.length - 1}
          >
            <ListItemIcon>
              <BusinessIcon />
            </ListItemIcon>
            {x.branchDescription}
          </MenuItem>
        ))}
    </div>
  );
};

BranchSelectionWidget.propTypes = {
  closeMenu: PropTypes.func,
  branches: PropTypes.array,
  onClick: PropTypes.func.isRequired,
};

export default BranchSelectionWidget;
